module.exports = __webpack_public_path__ + "static/media/listing-page-bali.e6e9a17f.webp";